import { FC, MouseEvent, ReactNode } from 'react';
import styles from './styles.module.scss';
import CloseButton from '../../../../../components/CloseButton';

export type TModalContentProps = {
  onMouseDown: (e: MouseEvent) => void;
  onClick: (e: MouseEvent) => void;
  onClose: VoidFunction;
  children: ReactNode;
};

const ModalContent: FC<TModalContentProps> = ({ onClick, onMouseDown, children, onClose }) => {
  return (
    <div className={styles.overlay} onMouseDown={onMouseDown} onClick={onClick}>
      <div className={styles.modalContainer}>
        <div className={styles.modal}>
          <CloseButton onClick={onClose} className={styles.close} color="green" size={24} tabletSize={24} iconSize={8} tabletIconSize={8} />
          <div className={styles.modalContent}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default ModalContent;
